import { defineMessages } from 'react-intl'

export default defineMessages({
  baseCurrencyLabel: {
    id: 'LegalEntityReview.baseCurrencyLabel',
    defaultMessage: 'Base currency',
  },
  externalIdLabel: {
    id: 'LegalEntityReview.externalIdLabel',
    defaultMessage: 'External ID',
  },
  countryLabel: {
    id: 'LegalEntityReview.countryLabel',
    defaultMessage: 'Country',
  },
  emptyValue: {
    id: 'LegalEntityReview.emptyValue',
    defaultMessage: 'None added',
  },
  editButton: {
    id: 'LegalEntityReview.editButton',
    defaultMessage: 'Edit',
  },
  confirmButton: {
    id: 'LegalEntityReview.confirmButton',
    defaultMessage: 'Confirm',
  },
})
